var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:[
    'open',
    'nav-item',
    'nav-dropdown',
    _vm.togglable ? 'togglable-dd' : 'no-togglable-dd'
  ],attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{class:[
      'nav-link',
      'nav-dropdown-toggle',
      _vm.togglable ? 'togglable' : 'no-togglable'
    ],on:{"click":_vm.handleToggle}},[(_vm.icon === 'cilMemory')?_c('CIcon',{staticClass:"svg-icon",attrs:{"content":_vm.cilMemory}}):_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+" ")],1),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }